import React from 'react';
import { Result, Button } from '@arco-design/web-react';
import { IconTool } from '@arco-design/web-react/icon';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const UnderConstruction = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <Result
        icon={<IconTool style={{ fontSize: 72 }} />}
        status="info"
        title={t('feedback.underConstruction')}
        subTitle={t('feedback.underConstructionDesc')}
        extra={[
          <Button
            key="back"
            type="primary"
            onClick={() => navigate(-1)}
          >
            {t('actions.back')}
          </Button>,
          <Button
            key="home"
            onClick={() => navigate('/dashboard')}
          >
            {t('actions.goToDashboard')}
          </Button>
        ]}
        style={{
          background: 'white',
          borderRadius: '12px',
          padding: '40px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
        }}
      />
    </div>
  );
};

export default UnderConstruction;